import React from 'react';

export default function MotionVoteBar({ counts = {} }) {
  const segments = [['animal', 'real'], ['unsure', 'unsure'], ['false_alarm', 'false']].map(([key, label]) => ({
    key, label, count: Number.isSafeInteger(counts[key]) && counts[key] > 0 ? counts[key] : 0,
  }));
  const total = segments.reduce((sum, segment) => sum + segment.count, 0);
  const description = total ? segments.map(({ label, count }) => `${count} ${label}`).join(', ') : 'No community votes yet';
  return <div className="cr-motion-votes" role="img" aria-label={`Community votes: ${description}`}>
    <div className="cr-motion-vote-labels" aria-hidden="true">{total ? segments.map(({ key, label, count }) => <span key={key}><i className={`cr-vote-${key}`} />{count} {label}</span>) : <span>No community votes yet</span>}</div>
    <div className="cr-motion-vote-bar" aria-hidden="true">{segments.filter(({ count }) => count > 0).map(({ key, label, count }) => <span key={key} className={`cr-vote-${key}`} style={{ width: `${count / total * 100}%` }} title={`${count} ${label} (${Math.round(count / total * 100)}%)`} />)}</div>
  </div>;
}
